import React, {useState, Fragment} from 'react';
import styled from 'styled-components';
import ProductPreview from './ProductPreview';
import Collapse from '@material-ui/core/Collapse';

const Wrapper = styled.div`
  grid-column: 1 / -1;
  height: 36px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  color: white;
  background: ${props => props.theme.subCategoriesBackgroundColor};
  cursor: pointer;
  font-size: 14px;
  font-weight: 900;
  letter-spacing: 0.4px;
  color: ${props => props.theme.subCategoriesFontColor};
  text-transform: uppercase;
`;

const SlideDownGrid = styled.div`
  grid-column: 1 / -1;
  display: grid;
  grid-gap: 24px 40px;
  grid-template-columns: ${props =>
    `repeat(${props.theme.productPreviewsPerRow}, 1fr)`};
  grid-gap: 20px;
  padding-bottom: 4px;
  @media (max-width: 786px) {
    grid-template-columns: 1fr;
  }
`;

const Chevron = styled.i`
  color: ${props => props.theme.subCategoriesFontColor};
`;

const SubCategory = ({subCategory, products, handleProductPreviewClick}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const selectProduct = productId =>
    products.find(product => product.product_id === productId);

  return (
    <Fragment>
      <Wrapper onClick={() => setIsExpanded(!isExpanded)}>
        {subCategory.name}
        <Chevron className={`fal fa-chevron-${isExpanded ? 'up' : 'down'}`} />
      </Wrapper>
      <Collapse in={isExpanded}>
        <SlideDownGrid>
          {subCategory.products.map(product => {
            if (selectProduct(product.product_id)) {
              return (
                <ProductPreview
                  id="MenuA-ProductPreview"
                  key={product.product_id}
                  product={selectProduct(product.product_id)}
                  handleProductPreviewClick={handleProductPreviewClick}
                />
              );
            }
          })}
        </SlideDownGrid>
      </Collapse>
    </Fragment>
  );
};

export default SubCategory;
